import { render, staticRenderFns } from "./CustomDaterange.vue?vue&type=template&id=f2e972e2&scoped=true&"
import script from "./CustomDaterange.vue?vue&type=script&lang=js&"
export * from "./CustomDaterange.vue?vue&type=script&lang=js&"
import style0 from "./CustomDaterange.vue?vue&type=style&index=0&id=f2e972e2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e972e2",
  null
  
)

export default component.exports